const DAYS_PER_WEEK = 7;
const HOURS_PER_DAY = 24;
const HALFHOURS_PER_DAY = 48;

export function normalizeHalfhoursMatrix(matrix?: boolean[][]): boolean[][] {
  return Array.from({ length: DAYS_PER_WEEK }, (_, day) => {
    const row = Array.isArray(matrix?.[day]) ? matrix[day] : [];
    return Array.from({ length: HALFHOURS_PER_DAY }, (_, halfhour) => row[halfhour] ?? false);
  });
}

export function toHourlyMatrix(halfhoursMatrix?: boolean[][]): boolean[][] {
  const normalized = normalizeHalfhoursMatrix(halfhoursMatrix);
  return Array.from({ length: DAYS_PER_WEEK }, (_, day) =>
    Array.from({ length: HOURS_PER_DAY }, (_, hour) => {
      const firstHalf = normalized[day][hour * 2];
      const secondHalf = normalized[day][hour * 2 + 1];
      return firstHalf || secondHalf;
    })
  );
}

export function toHalfhourMatrix(hourlyMatrix: boolean[][]): boolean[][] {
  return Array.from({ length: DAYS_PER_WEEK }, (_, day) => {
    const row = Array.isArray(hourlyMatrix[day]) ? hourlyMatrix[day] : [];
    return Array.from({ length: HALFHOURS_PER_DAY }, (_, halfhour) => row[Math.floor(halfhour / 2)] ?? false);
  });
}

/** Convert a 7x48 active-hours matrix to a `${day}-${halfhour}` cell key set. */
export function cellsFromHalfhoursMatrix(matrix?: boolean[][]): Set<string> {
  const cells = new Set<string>();
  const normalized = normalizeHalfhoursMatrix(matrix);
  for (let day = 0; day < DAYS_PER_WEEK; day++) {
    const row = normalized[day];
    for (let halfhour = 0; halfhour < HALFHOURS_PER_DAY; halfhour++) {
      if (row[halfhour]) cells.add(`${day}-${halfhour}`);
    }
  }
  return cells;
}

/** Inverse of {@link cellsFromHalfhoursMatrix}: build a 7x48 matrix from cell keys. */
export function halfhoursMatrixFromCells(cells: Set<string>): boolean[][] {
  const matrix = Array.from({ length: DAYS_PER_WEEK }, () =>
    Array.from({ length: HALFHOURS_PER_DAY }, () => false),
  );
  for (const cell of cells) {
    const [dayStr, halfhourStr] = cell.split('-');
    const day = Number(dayStr);
    const halfhour = Number(halfhourStr);
    if (day >= 0 && day < DAYS_PER_WEEK && halfhour >= 0 && halfhour < HALFHOURS_PER_DAY) {
      matrix[day][halfhour] = true;
    }
  }
  return matrix;
}
